import React from "react";
import FieldTripForm from "../Components/FieldTripForm";

const FieldTripPage = () => {
    return (
      <div>
        <FieldTripForm />
      </div>
    )
  }

export default FieldTripPage